import styled from 'styled-components'
import React, { useState } from 'react'
import { Alert, TouchableOpacity } from 'react-native'
import { colors } from 'infra/color'
import { RowLayout } from 'ui/common/layout'
import { ButtonText } from 'ui/common/text.tsx'
import { feedback } from 'api/writes.ts'
import { CustomPrompt } from 'ui/common/custom-prompt.tsx'
import { alert, alertError } from 'infra/util.ts'
import { CODEPUSH_VERSION } from 'infra/version.ts'
import { ButtonShadow } from 'ui/home/bottom-button-styles.ts'

const _TopButton = styled(TouchableOpacity)`
  background-color: white;
  border-radius: 999px;
  padding: 10px 14px;
`

export const FeedbackButton = () => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <>
      <_TopButton
        style={{ marginTop: 16, marginRight: 12, ...ButtonShadow }}
        onPress={() => setIsVisible(true)}
        onLongPress={() => Alert.alert('현재 버전', CODEPUSH_VERSION)}
      >
        <RowLayout style={{ alignItems: 'center' }}>
          <ButtonText style={{ color: colors.black }}>
            📄{'  '}의견을 들려주세요!
          </ButtonText>
        </RowLayout>
      </_TopButton>
      <CustomPrompt
        isVisible={isVisible}
        onConfirm={(inputText, setInputText) => {
          feedback(inputText.trim())
            .then(() => {
              alert(
                '피드백 완료',
                '의견이 잘 접수됐어요! 주신 피드백 반영해서 더 좋은 서비스를 만들게요 😊',
              )
              setInputText('')
            })
            .catch((e) => {
              alertError(e)
            })
            .finally(() => {
              setIsVisible(false)
            })
        }}
        onCancel={() => {
          setIsVisible(false)
        }}
      />
    </>
  )
}

export const TopRightButtonContainer = styled(RowLayout).attrs({
  pointerEvents: 'box-none',
})`
  position: absolute;
  right: 0;
`
